import { useState } from "react";
import ModalCloseIcon from "../../../assets/svg/close-modal.svg";
import { apiCall } from "../../../services/api-service";

import CommonStaticDropdown from "../../common/common_static_dropdown.jsx";
import { Row } from "react-bootstrap";

const StatusUpdateModal = ({ workOrderDetail, success, onHide }) => {
  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",
      padding: "16px 24px",
      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      width: "688px",
      maxHeight: "425px",
      textAlign: "center",
      overflowY: "auto",
    },
  };

  const [loading, setLoading] = useState(false);
  /*  const [enabledFields, setEnabledFields] = useState([]);
  const [mandatoryFields, setMandatoryFields] = useState([]);
  const getEnabledField = async () => {
    try {
      const response = await getEnabledFieldApi();
      if (response.success === true) {
        setEnabledFields(response?.enabled_fields ?? {});
        setMandatoryFields(response?.mandatory_fields ?? {});
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const isFieldEnabled = (field) => {
    return enabledFields.some((item) => item === field);
  };
  const isFieldMandatory = (field) => {
    return mandatoryFields.some((item) => item === field);
  }; */

  const [descriptionInputValue, setDescriptionInputValue] = useState("");
  const statusList = [
    { label: "InProgress", value: "InProgress" },
    { label: "Hold", value: "Hold" },
    { label: "Closed", value: "Closed" },
  ];
  const [statusOption, setStatusOption] = useState(null);
  const handleStatusSelect = (item) => {
    setStatusOption(item);
  };

  const [validations, setValidations] = useState({
    status: "",
    comment: "",
  });

  const statusUpdateApi = async () => {
    const data = {
      id: workOrderDetail.id,
      status: statusOption != null ? statusOption.value : "",
      comment: descriptionInputValue,
    };

    const response = await apiCall("post", "workorder/status_update", data);

    if (response?.status === 200 && response?.data?.success === true) {
      success();
    } else if (response?.data?.error) {
      const validationTemp = {
        status: "",
        comment: "",
      };
      Object.entries(response.data.error).forEach(([key, value]) => {
        validationTemp[key] = value.length === 0 ? "" : value[0];
      });
      setValidations(validationTemp);
    }
  };
  return (
    <div style={modalStyle.overlay}>
      <div style={modalStyle.modal}>
        <div style={{ color: "#ffffff" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
              }}
            >
              <div
                style={{
                  paddingLeft: "4px",
                  fontSize: "20px",
                  fontWeight: "500",
                  color: "#212129",
                }}
              >
                Status Update
              </div>
            </div>
            <img
              src={ModalCloseIcon}
              alt="close"
              onClick={onHide}
              style={{ cursor: "pointer" }}
            />
          </div>
          <div className="col-12">
            <label htmlFor="plate" className="form-label  fw-400 mt-3">
              Status
            </label>
            <CommonStaticDropdown
              items={statusList}
              placeholder="Select type"
              value={statusOption}
              onSelect={handleStatusSelect}
              enableSearch={false}
            />
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                fontSize: "12px",
                fontWeight: 400,
                color: "#FF4444",
                marginTop: "6px",
                marginLeft: "6px",
              }}
            >
              {validations.status}
            </span>
          </div>
          <div style={{ marginTop: "8px" }}>
            <div>
              <div>
                <div
                  style={{
                    paddingTop: "6px",
                    paddingBottom: "6x",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "13px",
                    fontWeight: "500",
                    color: "#212129",
                  }}
                >
                  Comment
                  <span style={{ color: "red" }}> *</span>
                </div>
                <textarea
                  type="text"
                  placeholder=" "
                  className="form-control mt-2"
                  value={descriptionInputValue}
                  rows={3}
                  onChange={(event) => {
                    setDescriptionInputValue(event.target.value); // Update state with input value
                  }}
                />
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                  }}
                >
                  {validations.comment}
                </span>
              </div>
            </div>

            <Row
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
                marginTop: "16px",
              }}
            >
              <div
                onClick={onHide}
                style={{
                  cursor: "pointer",
                  width: "176px",
                  height: "44px",
                  marginLeft: "8px",
                  marginRight: "8px",
                  borderRadius: "100px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#FFFFFF",
                  border: "0.6px solid #E5E5E5",
                }}
              >
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "700",
                    color: "#1E1E1E",
                  }}
                >
                  Cancel
                </div>
              </div>
              <div
                onClick={(e) => {
                  if (loading === false) {
                    statusUpdateApi();
                  }
                }}
                style={{
                  cursor: "pointer",
                  width: "176px",
                  height: "44px",
                  marginLeft: "8px",
                  marginRight: "8px",
                  borderRadius: "100px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#3253EB",
                }}
              >
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "700",
                    color: "#FFFFFF",
                  }}
                >
                  Submit
                </div>
              </div>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatusUpdateModal;
